let countryDataCache = null;

async function detectCustomerCountry() {
  const response = await fetch(window.Shopify.routes.root + "browsing_context_suggestions.json");
  return await response.json();
}

function getShippingBarElements() {
  const freeShippingBar = document.querySelector("#CartDrawer .free-shipping-bar");
  const wrapper = freeShippingBar ? freeShippingBar.closest(".cart-drawer__shipping-bar") : null;
  return { freeShippingBar, wrapper };
}

function hideFreeShippingBar() {
  const { freeShippingBar, wrapper } = getShippingBarElements();
  if (freeShippingBar) {
    freeShippingBar.classList.add("is-hidden");
  }
  if (wrapper) {
    wrapper.classList.add("is-hidden");
  }
}

function showFreeShippingBar() {
  const { freeShippingBar, wrapper } = getShippingBarElements();
  if (freeShippingBar) {
    freeShippingBar.classList.remove("is-hidden");
  }
  if (wrapper) {
    wrapper.classList.remove("is-hidden");
  }
}

function parseThresholds(thresholds) {
  const parsed = {};
  if (!thresholds || typeof thresholds !== "string") {
    return parsed;
  }

  thresholds.split(",").forEach(function (pair) {
    const trimmed = pair.trim();
    if (!trimmed) return;
    const parts = trimmed.split(":");
    if (parts.length < 2) return;
    const country = parts[0].trim();
    const amount = parseFloat(parts[1]);
    if (country && !isNaN(amount)) {
      parsed[country] = amount;
    }
  });

  return parsed;
}

function getThresholdAmount(parsedThresholds, visitorCountry) {
  if (visitorCountry && parsedThresholds[visitorCountry] != null) {
    return parsedThresholds[visitorCountry];
  }

  const keys = Object.keys(parsedThresholds);
  if (keys.length) {
    return parsedThresholds[keys[0]];
  }

  return null;
}

function applyFreeShippingBarSettings(countryData) {
  const { freeShippingBar, wrapper } = getShippingBarElements();
  if (!freeShippingBar || !wrapper) {
    return;
  }

  const visitorCountry =
    countryData?.detected_values?.country?.handle ||
    freeShippingBar.dataset.visitorCountry ||
    null;

  if (visitorCountry) {
    freeShippingBar.dataset.visitorCountry = visitorCountry;
  }

  const thresholds = freeShippingBar.dataset.thresholds || "";
  const subtotal = parseFloat(freeShippingBar.dataset.freeShippingSubtotal) / 100 || 0;
  const parsedThresholds = parseThresholds(thresholds);
  let thresholdAmount = getThresholdAmount(parsedThresholds, visitorCountry);

  if (thresholdAmount == null && freeShippingBar.dataset.thresholdAmount) {
    thresholdAmount = parseFloat(freeShippingBar.dataset.thresholdAmount);
  }

  if (thresholdAmount == null || isNaN(thresholdAmount)) {
    hideFreeShippingBar();
    return;
  }

  const amountLeft = Math.max(0, thresholdAmount - subtotal);
  const progress = Math.min(100, (subtotal / thresholdAmount) * 100);
  const amountLeftElement = freeShippingBar.querySelector(".amount-left-total");
  const moneyFormat =
    (typeof mlvMoneyFormat !== "undefined" && mlvMoneyFormat) ||
    (window.theme && theme.settings && theme.settings.moneyFormat) ||
    "{{amount}}";

  if (amountLeftElement) {
    const formattedAmount = amountLeft.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (moneyFormat.includes("{{amount_with_comma_separator}}")) {
      amountLeftElement.textContent = moneyFormat.replace(
        "{{amount_with_comma_separator}}",
        formattedAmount
      );
    } else if (moneyFormat.includes("{{amount}}")) {
      amountLeftElement.textContent = moneyFormat.replace("{{amount}}", formattedAmount);
    } else {
      amountLeftElement.textContent = formattedAmount;
    }
  }

  const progressBar = freeShippingBar.querySelector(".progress-bar");
  if (progressBar) {
    progressBar.style.width = progress + "%";
  }

  const congratsElement = freeShippingBar.querySelector(".congrats");
  const amountLeftElm = freeShippingBar.querySelector(".amount-left");
  if (amountLeft === 0) {
    freeShippingBar.classList.add("free-shipping-bar--complete");
    if (congratsElement) congratsElement.classList.remove("hide");
    if (amountLeftElm) amountLeftElm.classList.add("hide");
  } else {
    freeShippingBar.classList.remove("free-shipping-bar--complete");
    if (congratsElement) congratsElement.classList.add("hide");
    if (amountLeftElm) amountLeftElm.classList.remove("hide");
  }

  showFreeShippingBar();
}

function refreshFreeShippingBar(cart) {
  const { freeShippingBar } = getShippingBarElements();
  if (!freeShippingBar) {
    return;
  }

  if (!cart || cart.item_count === 0 || cart.total_price === 0) {
    hideFreeShippingBar();
    return;
  }

  freeShippingBar.dataset.freeShippingSubtotal = cart.total_price;

  if (freeShippingBar.dataset.visitorCountry) {
    countryDataCache = {
      detected_values: {
        country: {
          handle: freeShippingBar.dataset.visitorCountry,
        },
      },
    };
  }

  setTimeout(function () {
    applyFreeShippingBarSettings(countryDataCache);
  }, 100);
}

document.addEventListener("drawerOpen.CartDrawer", async function () {
  const cart = await theme.cart.getCart();
  refreshFreeShippingBar(cart);
});

document.addEventListener("cart:updated", async function (e) {
  refreshFreeShippingBar(e.detail && e.detail.cart);
});
